var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBtSchedule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_bt_schedule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Calendar_545370",
    "data-name": "noun Calendar 545370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    className: "cls-1",
    d: "M16.716,2H3.383A2.388,2.388,0,0,0,1,4.383V15.617A2.388,2.388,0,0,0,3.383,18H16.716A2.388,2.388,0,0,0,19.1,15.617V4.383A2.388,2.388,0,0,0,16.716,2ZM3.383,3.268H16.716a1.119,1.119,0,0,1,1.115,1.115V6.5H2.268V4.38A1.119,1.119,0,0,1,3.383,3.268ZM16.716,16.732H3.383a1.119,1.119,0,0,1-1.115-1.115V7.792H17.831v7.825A1.119,1.119,0,0,1,16.716,16.732Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-1",
    d: "M6.727,9.869H4.388a.634.634,0,0,0,0,1.268H6.727a.634.634,0,0,0,0-1.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    className: "cls-1",
    d: "M6.727,12.82H4.388a.634.634,0,0,0,0,1.268H6.727a.634.634,0,0,0,0-1.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    className: "cls-1",
    d: "M11.23,9.869H8.869a.634.634,0,0,0,0,1.268h2.339a.634.634,0,0,0,.634-.634.617.617,0,0,0-.6-.634Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    className: "cls-1",
    d: "M11.23,12.82H8.869a.634.634,0,0,0,0,1.268h2.339a.634.634,0,0,0,.634-.634.617.617,0,0,0-.6-.634Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    className: "cls-1",
    d: "M15.711,9.869H13.372a.634.634,0,0,0,0,1.268h2.339a.634.634,0,0,0,0-1.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    className: "cls-1",
    d: "M15.711,12.82H13.372a.634.634,0,0,0,0,1.268h2.339a.634.634,0,1,0,0-1.268Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    className: "cls-1",
    cx: 5.088,
    cy: 4.864,
    r: 0.962
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    className: "cls-1",
    cx: 15.011,
    cy: 4.864,
    r: 0.962
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBtSchedule);
export default __webpack_public_path__ + "static/media/icon_bt_schedule.e5187747085eb7efb01a579fa001c01d.svg";
export { ForwardRef as ReactComponent };